import routerMap from './router.map'
import {parseRoutes} from '@/utils/routerUtil'

// 异步路由配置
const routesConfig = [
  'login',
  'jump',
  'silent',
  'popup',
  'root',
  {
    router: 'exp404',
    path: '*',
    name: '404',
    errorPage:true
  },
  {
    router: 'exp403',
    path: '/403',
    name: '403',
    errorPage:true
  }
]
const options = {
  routes: parseRoutes(routesConfig, routerMap)
}

export default options
